export const STORY_SECTION = {
  TITLE: 'Our Story',

  SUBTITLE:
    'Rooted in the legacy of the Institute of Interpersonal Hypnotherapy (IIH), founded by\nMatthew J. Brownstein, Nirva carries forward over 18 years of teaching excellence and a network of 1,000+ graduates. Matthew brings more than 30 years of experience in holistic health, spirituality, and energy medicine, with over 30,000 hours of hands-on and teaching experience.',

  QUOTE_PRIMARY: 'Beautiful Thinking — The Quiet Shift\nOf A Mind Remembering Its Peace',

  QUOTE_SECONDARY:
    'Nirva represents the resolution of the human search for clarity and inner truth. It is the gentle turning of awareness inward—what A Course in Miracles calls a miracle.',

  QUOTE_TERTIARY:
    'Through Nirva, the IIH legacy becomes\naccessible globally—offering affordable, ethical, and heart-centered care online.',

  JOURNEY_TITLE: "Each client's journey follows a holistic path:",

  BUTTON_LABEL: 'Explore Our Services',
};
